import {Profile} from '../../models';
import {API} from '../types';

type GetReliefStaffsParams = {
  _start: number;
  _limit: number;
  _sort: any;
  query?: string;
  skillIds?: number[];
  medicalExpiredAt_lt?: string;
};

interface Response {
  list: Profile[];
  total: number;
}

export function getReliefStaffsAPI(
  params: GetReliefStaffsParams
): API<Response> {
  const urlParams = {
    ...params,
    ...(params.skillIds && {skillIds: params.skillIds.join(',')}),
  };
  return {
    getData: async client => {
      const {data} = await client({
        url: '/profiles/relief-staffs',
        method: 'GET',
        params: urlParams,
      });
      return {data: data};
    },
    getMockData: () => {
      return {list: [], total: 0};
    },
  };
}
